import React, { createContext, useContext } from 'react';
const BleedContext = createContext({ bleedClassName: '' });
export const BleedProvider = ({ bleedClassName, children, }) => {
    return (React.createElement(BleedContext.Provider, { value: {
            bleedClassName,
        } }, children));
};
export const useBleedContext = () => {
    return useContext(BleedContext);
};
//# sourceMappingURL=BleedContext.js.map